module.exports = __webpack_public_path__ + "static/media/bg-site.0ffec0f.webm";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build902/assets/bg-site.webm
// module id = jb0E
// module chunks = 42